export const formatDateForDisplay = (date: Date | string) => {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
};

export const getEquidistantRangeFromMinMax = (range: {min: number; max: number}) => {
  const numberOfTicks = 5;

  if (range.min === range.max) {
    return [range.min];
  }

  const gap = (range.max - range.min) / (numberOfTicks - 1);

  const getPosition = (index: number) => range.min + index * gap;
  return Array.from([...Array(numberOfTicks)]).map((_, index) => getPosition(index));
};
